import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiModel } from './api.model';
import {
    userBrandVisibilityFileUrl,
    productCategoriesFileUrl,
    discountBrandsFileUrl,
    organizationFeatureFlagsFileUrl,
    categoriesConfigurationFileUrl
} from 'config';
import { MainCategoryTranslationAndSorting } from 'app/b2b-order/components/category-list/category-list.component';

export enum S3File {
    UserBrandVisibility = 'user-brand-visibility',
    ProductCategories = 'product-categories',
    CategoriesConfiguration = 'categories-configuration',
    DiscountBrands = 'discount-brands',
    OrganizationFeatureFlags = 'organization-feature-flags'
}

export interface ProductCategory {
    name: string;
    fcKey: string;
    translationKey: string;
    subCategories?: ProductCategory[];
}

export enum FeatureId {
    ORDER_SHEET_PDF_DOWNLOAD = 'ORDER_SHEET_PDF_DOWNLOAD',
    DYNAMIC_BRANDS_CATEGORY_FILTER = 'DYNAMIC_BRANDS_CATEGORY_FILTER'
}

@Injectable()
export class S3FileModel {
    private readonly files = {
        [S3File.UserBrandVisibility]: userBrandVisibilityFileUrl,
        [S3File.ProductCategories]: productCategoriesFileUrl,
        [S3File.DiscountBrands]: discountBrandsFileUrl,
        [S3File.OrganizationFeatureFlags]: organizationFeatureFlagsFileUrl,
        [S3File.CategoriesConfiguration]: categoriesConfigurationFileUrl
    };

    constructor(private apiModel: ApiModel) {}

    public getJSON(file: S3File.UserBrandVisibility): Observable<{ [userId: string]: string[] }>;
    public getJSON(file: S3File.ProductCategories): Observable<ProductCategory[]>;
    public getJSON(file: S3File.DiscountBrands): Observable<{ [brandId: string]: number }>;
    public getJSON(file: S3File.OrganizationFeatureFlags): Observable<{ [key in FeatureId]: string[] }>;
    public getJSON(file: S3File.CategoriesConfiguration): Observable<MainCategoryTranslationAndSorting>;
    public getJSON(file: S3File): Observable<any> {
        return this.apiModel.makeHttpObservableRequest({
            method: 'GET',
            url: this.files[file],
            headers: { 'Cache-Control': 'no-cache' }
        });
    }
}
